import Vue from '../../node_modules/vue';
import Vuex from '../../node_modules/vuex';

Vue.use(Vuex);

const store = () => new Vuex.Store({
    state: {
        commonData: {
            auth: false,
        },
        auth: false,
        cachedList: [],
    },
    mutations: {
        setCommonData(state, { commonData }) {
            state.commonData = commonData;
        },
        setAuth(state, { auth }) {
            state.auth = auth;
        },
        setCachedList(state, { list }) {
            state.cachedList = list;
        },
    },
});

export default store;
